// An object containing all of the general colors
// Used to build required Tailwind CSS classes, which is done in the tailwind.config.js file
// Also imported into the portfolio repo https://github.com/elanco/commercial-web-portfolioPet and used for the brand configs model as code

export const generalColors: Record<
	string,
	{
		name: string
		backgroundColor: string
		lightBackgroundColor: string
		accentColor?: string
	}
> = {
	primary: {
		name: 'Primary',
		backgroundColor: '#0072CE',
		lightBackgroundColor: 'black',
		accentColor: '#0584EB',
	},
	primary_dark: {
		name: 'Primary Dark',
		backgroundColor: '#04538D',
		lightBackgroundColor: 'default',
	},
	secondary: {
		name: 'Secondary Teal',
		backgroundColor: '#00AB9C',
		lightBackgroundColor: 'default',
	},
	seresto: {
		name: 'Seresto',
		backgroundColor: '#00597c',
		lightBackgroundColor: 'default',
	},
	tertiary: {
		name: 'Tertiary',
		backgroundColor: '#FFFFFF',
		lightBackgroundColor: 'default',
		accentColor: '#0072CE',
	},
	pet_primary_green: {
		name: 'Pet Primary Green',
		backgroundColor: '#1F8815',
		lightBackgroundColor: 'default',
	},
	orange: {
		name: 'Orange',
		backgroundColor: '#ee7d00',
		lightBackgroundColor: 'default',
		accentColor: '#ff9900',
	},
	grey: {
		name: 'Grey',
		backgroundColor: '#F5F5F5',
		lightBackgroundColor: 'default',
	},
	inverted: {
		name: 'Inverted Primary',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
		accentColor: '#0072CE',
	},
	inverted_pet_primary_green: {
		name: 'Inverted Pet Primary Green',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
		accentColor: '#1F8815',
	},
	inverted_black: {
		name: 'Inverted Black',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
		accentColor: '#000000',
	},
	orange_inverted: {
		name: 'Inverted Orange',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
		accentColor: '#ee7d00',
	},
	black: {
		name: 'Black',
		backgroundColor: '#000000',
		lightBackgroundColor: 'default',
	},
	midnight_blue: {
		name: 'Midnight Blue',
		backgroundColor: '#001149',
		lightBackgroundColor: 'default',
	},
	salmonella_360: {
		name: 'Salmonella 360',
		backgroundColor: '#EE7D00',
		lightBackgroundColor: 'default',
	},
	zenrelia_primary: {
		name: 'Zenrelia Primary',
		backgroundColor: '#215447',
		lightBackgroundColor: 'default',
	},
	zenrelia_secondary: {
		name: 'Zenrelia Secondary',
		backgroundColor: '#91CC12',
		lightBackgroundColor: 'default',
	},
	zenrelia_contrast: {
		name: 'Zenrelia Contrast',
		backgroundColor: '#A68CFA',
		lightBackgroundColor: 'default',
	},
	zenrelia_accent: {
		name: 'Zenrelia Accent',
		backgroundColor: '#c0d29a',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku1: {
		name: 'Zenrelia Sku1',
		backgroundColor: '#618582',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku2: {
		name: 'Zenrelia Sku2',
		backgroundColor: '#8752C7',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku3: {
		name: 'Zenrelia Sku3',
		backgroundColor: '#00A99E',
		lightBackgroundColor: 'default',
	},
	zenrelia_sku4: {
		name: 'Zenrelia Sku4',
		backgroundColor: '#C6B5FF',
		lightBackgroundColor: 'default',
	},
	claro_neptra: {
		name: 'Claro / Neptra',
		backgroundColor: '#522873',
		lightBackgroundColor: 'default',
	},
	clik_light_blue: {
		name: 'CLiK Light Blue',
		backgroundColor: '#0C78BD',
		lightBackgroundColor: 'default',
	},
	clik_dark_blue: {
		name: 'CLiK Dark Blue',
		backgroundColor: '#1F3560',
		lightBackgroundColor: 'default',
	},
	clik_yellow: {
		name: 'CLiK Yellow',
		backgroundColor: '#DB9300',
		lightBackgroundColor: 'default',
	},
	tracer: {
		name: 'Tracer',
		backgroundColor: '#ed037c',
		lightBackgroundColor: 'default',
	},
	advocate_orange: {
		name: 'Advocate Orange',
		backgroundColor: '#E57200',
		lightBackgroundColor: 'default',
	},
	elanco_blue: {
		name: 'Elanco Blue',
		backgroundColor: '#0072CE',
		lightBackgroundColor: 'default',
	},
	elanco_beige: {
		name: 'Elanco Beige',
		backgroundColor: '#D5C4AF',
		lightBackgroundColor: 'default',
	},
	elanco_grey: {
		name: 'Elanco Grey',
		backgroundColor: '#7F7F7F',
		lightBackgroundColor: 'default',
	},
	pet_green: {
		name: 'Pet Green',
		backgroundColor: '#1F8815',
		lightBackgroundColor: 'default',
	},
	vet: {
		name: 'Vet',
		backgroundColor: '#3818A2',
		lightBackgroundColor: 'default',
	},
	vet_purple: {
		name: 'Vet Purple',
		backgroundColor: '#3818A2',
		lightBackgroundColor: 'default',
	},
	white: {
		name: 'White',
		backgroundColor: '#FFFFFF',
		lightBackgroundColor: 'default',
	},
	elanco_green: {
		name: 'Elanco Green',
		backgroundColor: '#0EC3A4',
		lightBackgroundColor: 'default',
	},
	light_gray: {
		name: 'Light Gray',
		backgroundColor: '#f2f2f2',
		lightBackgroundColor: 'default',
	},
	light_blue: {
		name: 'Light Blue',
		backgroundColor: '#D9EAF8',
		lightBackgroundColor: 'default',
	},
	mid_beige: {
		name: 'Mid Beige',
		backgroundColor: '#EEE8DF',
		lightBackgroundColor: 'default',
	},
	pet_green_light: {
		name: 'Pet Green Light',
		backgroundColor: '#CAE3C8',
		lightBackgroundColor: 'default',
	},
	purple_light: {
		name: 'Purple Light',
		backgroundColor: '#EAE6F5',
		lightBackgroundColor: 'default',
	},
	kexxtone: {
		name: 'Kexxtone',
		backgroundColor: '#FFD000',
		lightBackgroundColor: 'default',
	},
	zolvix_orange: {
		name: 'Zolvix Orange',
		backgroundColor: '#FF5F1F',
		lightBackgroundColor: 'default',
	},
	no_style: {
		name: 'Purple Light (Category)',
		backgroundColor: '#EAE6F5',
		lightBackgroundColor: 'default',
	},
	behaviour: {
		name: 'Medium Red',
		backgroundColor: '#d43900',
		lightBackgroundColor: 'default',
	},
	bovaer: {
		name: 'Bovaer',
		backgroundColor: '#027d50',
		lightBackgroundColor: 'default',
	},
	pradalex: {
		name: 'Pradalex',
		backgroundColor: '#26d07c',
		lightBackgroundColor: 'default',
	},
	new_pets: {
		name: 'Dark Pink',
		backgroundColor: '#bd2ca2',
		lightBackgroundColor: 'default',
	},
	lifestyle: {
		name: 'Darker Red',
		backgroundColor: '#b50000',
		lightBackgroundColor: 'default',
	},
	health_and_care: {
		name: 'Teal',
		backgroundColor: '#138187',
		lightBackgroundColor: 'default',
	},
	parasites: {
		name: 'Royal Blue',
		backgroundColor: '#3a76bb',
		lightBackgroundColor: 'default',
	},
	danger: {
		name: 'Red',
		backgroundColor: '#EA0101',
		lightBackgroundColor: 'default',
		accentColor: '#BE0202',
	},
	none: {
		name: 'None (Transparent)',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
	},
	transparent: {
		name: 'Transparent',
		backgroundColor: '#FFFFFF00',
		lightBackgroundColor: 'default',
	},
	galliprant_yellow: {
		name: 'Galliprant Yellow',
		backgroundColor: '#ffc600',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_yellow: {
		name: 'Gallipro Fit yellow',
		backgroundColor: '#FBBA00',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_orange: {
		name: 'Gallipro Fit orange',
		backgroundColor: '#EF7900',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_green: {
		name: 'Gallipro Fit green',
		backgroundColor: '#9EB184',
		lightBackgroundColor: 'default',
	},
	gallipro_fit_darkblue: {
		name: 'Gallipro Fit darkblue',
		backgroundColor: '#142C46',
		lightBackgroundColor: 'default',
	},
	neptra_green: {
		name: 'Neptra green',
		backgroundColor: '#c7d530',
		lightBackgroundColor: 'default',
	},
	avipro_grey: {
		name: 'Avipro Grey',
		backgroundColor: '#929292',
		lightBackgroundColor: 'default',
	},
	avipro_red: {
		name: 'Avipro Red',
		backgroundColor: '#d51317',
		lightBackgroundColor: 'default',
	},
	aviblue_light_blue: {
		name: 'AviBlue Light Blue',
		backgroundColor: '#41c0f0',
		lightBackgroundColor: 'default',
	},
	aviblue_mid_blue: {
		name: 'AviBlue Mid Blue',
		backgroundColor: '#0078BF',
		lightBackgroundColor: 'default',
	},
	aviblue_dark_blue: {
		name: 'AviBlue Dark Blue',
		backgroundColor: '#073F65',
		lightBackgroundColor: 'default',
	},
	coliprotec_teal: {
		name: 'Coliprotec Teal',
		backgroundColor: '#0081a3',
		lightBackgroundColor: 'default',
	},
	flubenvet: {
		name: 'Flubenvet',
		backgroundColor: '#788e1d',
		lightBackgroundColor: 'default',
	},
	hemicell_red: {
		name: 'Hemicell Red',
		backgroundColor: '#b32b2e',
		lightBackgroundColor: 'default',
	},
	htsi: {
		name: 'HTSI',
		backgroundColor: '#004268',
		lightBackgroundColor: '#e5f0ec',
	},
	maxiban_: {
		name: 'Maxiban',
		backgroundColor: '#d31245',
		lightBackgroundColor: 'default',
	},
	onsior: {
		name: 'Onsior',
		backgroundColor: '#00a9ce',
		lightBackgroundColor: 'default',
	},
	onsior_cool_gray_10: {
		name: 'Onsior Cool Gray 10',
		backgroundColor: '#63666a',
		lightBackgroundColor: 'default',
	},
	onsior_tangerine: {
		name: 'Onsior Tangerine',
		backgroundColor: '#ffb81c',
		lightBackgroundColor: 'default',
	},
	onsior_dark_gray: {
		name: 'Onsior Dark Gray',
		backgroundColor: '#2c2a29',
		lightBackgroundColor: 'default',
	},
	onsior_cool_gray_6c: {
		name: 'Onsior Cool Gray 6C',
		backgroundColor: '#a7a8aa',
		lightBackgroundColor: 'default',
	},
	onsior_dark_red: {
		name: 'Onsior Dark Red',
		backgroundColor: '#9d2235',
		lightBackgroundColor: 'default',
	},
	onsior_vivid_orange: {
		name: 'Onsior Vivid Orange',
		backgroundColor: '#ff671f',
		lightBackgroundColor: 'default',
	},
	onsior_dark_violet: {
		name: 'Onsior Dark Violet',
		backgroundColor: '#3c1053',
		lightBackgroundColor: 'default',
	},
	onsior_lime_green: {
		name: 'Onsior Lime Green',
		backgroundColor: '#00b140',
		lightBackgroundColor: 'default',
	},
	onsior_dark_blue: {
		name: 'Onsior Dark Blue',
		backgroundColor: '#003594',
		lightBackgroundColor: 'default',
	},
	onsior_rhodamine_red: {
		name: 'Onsior Rhodamine Red',
		backgroundColor: '#e10098',
		lightBackgroundColor: 'default',
	},
	onsior_advantix_light: {
		name: 'Onsior Advantix Light',
		backgroundColor: '#f9e5eb',
		lightBackgroundColor: 'default',
	},
	agita_10wg: {
		name: 'Agita 10WG',
		backgroundColor: '#7ea0c4',
		lightBackgroundColor: 'default',
	},
	baseline: {
		name: 'Baseline',
		backgroundColor: '#db3168',
		lightBackgroundColor: 'default',
	},
	baytril_100: {
		name: 'Baytril 100',
		backgroundColor: '#008f87',
		lightBackgroundColor: 'default',
	},
	evosure: {
		name: 'Evosure',
		backgroundColor: '#e56606',
		lightBackgroundColor: 'default',
	},
	feedaid: {
		name: 'FeedAid',
		backgroundColor: '#729786',
		lightBackgroundColor: 'default',
	},
	full_value_pork_primary_blue: {
		name: 'Full Value Pork Primary Blue',
		backgroundColor: '#004267',
		lightBackgroundColor: 'default',
	},
	full_value_pork_secondary_blue: {
		name: 'Full Value Pork Secondary Blue',
		backgroundColor: '#30a9d7',
		lightBackgroundColor: 'default',
	},
	lipinate: {
		name: 'Lipinate',
		backgroundColor: '#464c3e',
		lightBackgroundColor: 'default',
	},
	pili_shield_plus_c: {
		name: 'Pili Shield +C',
		backgroundColor: '#7f2629',
		lightBackgroundColor: 'default',
	},
	proteck: {
		name: 'Proteck',
		backgroundColor: '#cc9000',
		lightBackgroundColor: 'default',
	},
	rhini_shield: {
		name: 'Rhini Shield',
		backgroundColor: '#009383',
		lightBackgroundColor: 'default',
	},
	swine_awake: {
		name: 'Swine Awake',
		backgroundColor: '#7b2379',
		lightBackgroundColor: 'default',
	},
	tempo_one_percent_dust: {
		name: 'Tempo 1% Dust',
		backgroundColor: '#75bc43',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_guard_dog: {
		name: 'Credelio Quattro Guard Dog',
		backgroundColor: '#0F3320',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_hunter_green: {
		name: 'Credelio Quattro Hunter Green',
		backgroundColor: '#00643C',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_grass_green: {
		name: 'Credelio Quattro Grass Green',
		backgroundColor: '#009548',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_tennis_ball_green: {
		name: 'Credelio Quattro Tennis Ball Green',
		backgroundColor: '#80BB4F',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_park_green: {
		name: 'Credelio Quattro Park Green',
		backgroundColor: '#94CE95',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_golden: {
		name: 'Credelio Quattro Golden',
		backgroundColor: '#F68A33',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_milk_bone: {
		name: 'Credelio Quattro Milk Bone',
		backgroundColor: '#EDECDE',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_frisbee: {
		name: 'Credelio Quattro Frisbee',
		backgroundColor: '#EC008C',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_sunny_day: {
		name: 'Credelio Quattro Sunny Day',
		backgroundColor: '#EAAC18',
		lightBackgroundColor: 'default',
	},
	credelio_quattro_sky_blue: {
		name: 'Credelio Quattro Sky Blue',
		backgroundColor: '#0099D8',
		lightBackgroundColor: 'default',
	},
	pet_protect_red: {
		name: 'Pet Protect - Red',
		backgroundColor: '#F9423A',
		lightBackgroundColor: 'default',
	},
	pet_protect_green: {
		name: 'Pet Protect - Green',
		backgroundColor: '#13863D',
		lightBackgroundColor: 'default',
	},
	pet_protect_blue: {
		name: 'Pet Protect - Blue',
		backgroundColor: '#49B2E6',
		lightBackgroundColor: 'default',
	},
	clean_up_2: {
		name: 'Clean Up II',
		backgroundColor: '#92C050',
		lightBackgroundColor: 'default',
	},
	cydectin: {
		name: 'Cydectin',
		backgroundColor: '#5C4586',
		lightBackgroundColor: 'default',
	},
	micotil: {
		name: 'Micotil',
		backgroundColor: '#13B5EA',
		lightBackgroundColor: 'default',
	},
	scour_bos: {
		name: 'Scour Bos',
		backgroundColor: '#6A2875',
		lightBackgroundColor: 'default',
	},
	vira_shield: {
		name: 'Vira Shield',
		backgroundColor: '#E05A28',
		lightBackgroundColor: 'default',
	},
	pet_protect_skin: {
		name: 'Pet Protect Skin',
		backgroundColor: '#25B0E7',
		lightBackgroundColor: 'default',
	},
	pet_protect_calm: {
		name: 'Pet Protect Calm',
		backgroundColor: '#C05694',
		lightBackgroundColor: 'default',
	},
	pet_protect_allergy: {
		name: 'Pet Protect Allergy',
		backgroundColor: '#70B925',
		lightBackgroundColor: 'default',
	},
	civ: {
		name: 'CIV',
		backgroundColor: '#CFB62E',
		lightBackgroundColor: 'default',
	},
	elmaro_navy_blue: {
		name: 'Elmaro Navy Blue',
		backgroundColor: '#00457f',
		lightBackgroundColor: 'default',
	},
	elmaro_pink: {
		name: 'Elmaro Pink',
		backgroundColor: '#eb7bae',
		lightBackgroundColor: 'default',
	},
	elmaro_yellow: {
		name: 'Elmaro Yellow',
		backgroundColor: '#fbba00',
		lightBackgroundColor: 'default',
	},
	galliprant_red: {
		name: 'Galliprant Red',
		backgroundColor: '#d11947',
		lightBackgroundColor: 'default',
	},
	bexacat_dark_grey: {
		name: 'Bexacat Dark Grey',
		backgroundColor: '#262626',
		lightBackgroundColor: 'default',
	},
	varenzin_blue: {
		name: 'Varenzin Blue',
		backgroundColor: '#0056b8',
		lightBackgroundColor: 'default',
	},
	varenzin_purple: {
		name: 'Varenzin Purple',
		backgroundColor: '#6a488e',
		lightBackgroundColor: 'default',
	},
	nuplura_ph_plus_5_primary: {
		name: 'Nuplura PH+5 Primary',
		backgroundColor: '#a1d060',
		lightBackgroundColor: 'default',
	},
	nuplura_ph_plus_5_secondary: {
		name: 'Nuplura PH+5 Secondary',
		backgroundColor: '#8b8c90',
		lightBackgroundColor: 'default',
	},
	rosa_xo_verme: {
		name: 'Rosa - Xô Verme',
		backgroundColor: '#e82e8a',
		lightBackgroundColor: 'default',
	},
	catosal_metabol: {
		name: 'Catosal Metabol',
		backgroundColor: '#FF3399',
		lightBackgroundColor: 'default',
	},
	befrena_primary_blue: {
		name: 'Befrena Primary Blue',
		backgroundColor: '#0F4597',
		lightBackgroundColor: 'default',
	},
	befrena_accent_green: {
		name: 'Befrena Accent Green',
		backgroundColor: '#8CC63E',
		lightBackgroundColor: 'default',
	},
	befrena_accent_pink: {
		name: 'Befrena Accent Pink',
		backgroundColor: '#E79FC6',
		lightBackgroundColor: 'default',
	},
	zolvix_plus_green: {
		name: 'Zolvix Plus Green',
		backgroundColor: '#105742',
		lightBackgroundColor: 'default',
	},
	zolvix_plus_orange: {
		name: 'Zolvix Plus Orange',
		backgroundColor: '#ED7203',
		lightBackgroundColor: 'default',
	},
	eluracat_dark_pink: {
		name: 'Eluracat Dark Pink',
		backgroundColor: '#AB1368',
		lightBackgroundColor: 'default',
	},
	eluracat_light_pink: {
		name: 'Eluracat Light Pink',
		backgroundColor: '#E10098',
		lightBackgroundColor: 'default',
	},
	eluracat_yellow: {
		name: 'Eluracat Yellow',
		backgroundColor: '#FDBA12',
		lightBackgroundColor: 'default',
	},
	milbemax_blue: {
		name: 'Milbemax Blue',
		backgroundColor: '#004e8f',
		lightBackgroundColor: '#83AFD6',
	},
	milbemax_red: {
		name: 'Milbemax Red',
		backgroundColor: '#B10035',
		lightBackgroundColor: '#F9E5EB',
	},
	trucan_ultra_blue: {
		name: 'Trucan Ultra Blue',
		backgroundColor: '#1A4278',
		lightBackgroundColor: 'default',
	},
	trucan_ultra_yellow: {
		name: 'Trucan Ultra Yellow',
		backgroundColor: '#FCC924',
		lightBackgroundColor: 'default',
	},
}
